<template>
    <div ref="menu" :class="['header', 'clearfix', 'light', {'mobile': isMobile}, { show: show }, {collasp: collasp}]" @click="handleClickMenu">
        <div v-if="isMobile" class="mobile-header">
            <div @click="changeRoute('/')" class="f-left">
                <img class="logo" src="@/assets/image/logo-light.svg" alt="">
            </div>
            <div :class="['menu-icon', 'f-right', show ? 'show' : 'hide']" @click="show = !show"></div>
        </div>
        <div v-else @click="changeRoute('/')" class="f-left">
            <img class="logo" src="@/assets/image/logo-light.svg" alt="">
        </div>
        <div :class="[isMobile ? 'menu-list':'f-right', show ? 'show' : 'hide']">
            <template  v-for="p in navText.navigator">
                <div 
                    v-if="p.block" 
                    :key="p.name"
                    :class="['block', {'active-main': checkActive(p)}]" 
                    @mouseenter="setSecondNav(p, true)" 
                    @mouseleave="setSecondNav(p, false)"
                    >
                        <span :class="{active: p.show }" v-if="isMobile" @click="toggleChildNav(p)">{{p.name}}</span>
                        <span v-else>{{p.name}}</span>
                        <ul :class="['second-nav clearfix', { show: p.show, center: p.children.length === 1 }]">
                            <li :class="{'has-child': !c.path}" v-for="c in p.children" :key="c.name">
                                <a v-if="c.path" @click="changeRoute(`${c.path}`, p)"><span>{{ c.name }}</span></a>
                                <div class="block" v-else
                                    @mouseenter="setSecondNav(c, true)" 
                                    @mouseleave="setSecondNav(c, false)"
                                    >   
                                        <span :class="{active: c.show}" v-if="isMobile" @click="toggleChildNav(c)">{{ c.name }}</span>
                                        <span v-else>{{ c.name }}</span>
                                        <ul 
                                            v-if="c.block" 
                                            :class="['third-nav', {show: c.show}]"                                    >
                                            <li :class="{title: t.title}" v-for="t in c.children" :key="t.name || t.title">
                                                <span v-if="t.title">{{ t.title }}</span>
                                                <a :data="c.path" v-else @click="changeRoute(`${t.path}`, c, p)"><span>{{ t.name }}</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                
                            </li>
                        </ul>
                    </div>
                <a 
                    v-else
                    :key="p.path+1" 
                    :class="['normal', {'active-main': pathName === p.path || pathName === p.path + '/'}]" 
                    @click="changeRoute(`${p.path}`)">{{p.name}}</a>
            </template>
            <!-- <a v-if="isMobile && $route.path!=='/CN/bigdataplatform'" class="normal" @click="handleSetLang"><i :class="{passive: $route.params.lang!=='EN'}">CN</i>/<i :class="{passive: $route.params.lang ==='EN'}">EN</i></a> -->
<!--            <div v-else-if="$route.path!=='/CN/bigdataplatform'" @click="handleSetLang" :class="[$route.params.lang === 'EN' ? 'cn-btn' : 'en-btn']"></div>-->
            <!-- <div v-if="$route.path!=='/CN/bigdataplatform'" @click="handleSetLang" :class="[$route.params.lang === 'EN' ? 'cn-btn' : 'en-btn']"></div> -->
            <!-- <div v-else style="height: 24px;width: 40px;"></div> -->
        </div>
    </div>
</template>
<script>
import { isMobile } from '@/js/utils';
import { header } from '@/js/text'
import { mapState, mapMutations } from 'vuex';
export default {
    name: 'navigation', 
    data() {
        return {
            pathName: null,
            isMobile: false,
            show: false,
            timer: null,
            collasp: false,
            navText: null,
            showArr: []
        }
    },
    computed: {
        ...mapState(['headerStyle']),
        lang: {
            get() {
                return this.$route.params.lang
            },
            set() {}
        },
        text() {            
            return this.$route.params.lang === 'CN' ? header.CN : header.EN
        }
    },
    watch: {
        $route(val) {
            if(val.params.lang) {
                this.lang = val.params.lang
            }else {
                this.lang = 'CN'
            }
            this.showArr.forEach(item => {
                item.show = false
            })
            this.showArr = []
            this.navText = this.text
            this.pathName = val.fullPath.slice(3)
            this.show = false
        },
        show(val) {
            clearTimeout(this.timer)
            let app = document.getElementById('app')
            let height = window.innerHeight
            val ? app.style=`height: ${height}px; overflow: hidden` : app.style="height:auto; overflow: inherit"
            if(!val) {
                this.showArr.forEach(item => {
                    item.show = false
                })
                this.showArr = []
            }
        }
    },
    methods: {
        changeRoute(p, block, parent) {
            let path = `/${this.$route.params.lang}${p}`;
            if(path === this.$route.fullPath || path + '/' === this.$route.fullPath || path === this.$route.fullPath + '/') {
                window.location.reload()
            }else if(p.includes('http')){
                window.open(p, "_blank");
            }else {
                this.$router.push({path})
                if(block) {
                    block.show = false
                }
                if(parent) {
                    parent.show = false
                }
            }
        },
        handleClickMenu(e) {      
            if(Array.from(e.target.classList).includes('menu-list')) {
                this.show = false
            }
        },
        handleSetLang() {
            let lang = this.lang === 'CN' || !this.lang ? 'EN' : 'CN'
            this.$router.push({path: `/${lang}${this.$route.path.slice(3)}`})
        },
        setSecondNav(p, b) {            
            if(!this.isMobile) {
                p.show = b
            }
        },
        toggleChildNav(p) {
            p.show = !p.show
            if(p.show) {           
                let findItem = this.showArr.find(item => item.level === p.level)
                if(findItem) {
                    findItem.show = false
                    let index = this.showArr.findIndex(item => item === findItem)
                    this.showArr.splice(index, 1, p)
                    findItem.children.forEach(item => {
                    if(item.show) {
                        this.toggleChildNav(item)
                    }
                }) 
                }else {
                    this.showArr.push(p)
                }
            }else {      
                p.children.forEach(item => {
                    if(item.show) {
                        this.toggleChildNav(item)
                    }
                })          
                let index = this.showArr.findIndex(item => item === p)
                this.showArr.splice(index, 1)
            }
        },
        checkActive(p) {
            let check = p.children.some(c => {
                if(c.children) {
                    return this.checkActive(c)
                }else {
                    return c.path === this.pathName || c.path + '/' === this.pathName
                }
            })
            return check
        }
    },
    created() {
        this.pathName = this.$route.fullPath        
        this.navText = this.text
        this.isMobile = window.innerWidth <= 600 || isMobile()
        window.addEventListener('resize', ()=> {
            this.isMobile = window.innerWidth <= 600 || isMobile()
        })
    },
    mounted() {
        this.pathName = this.$route.fullPath.slice(3);
        if(isMobile()) {
            this.$refs.menu.ontouchstart = (e) => {
                let path = Array.from(e.path)
                let check = path.some(ele => ele.className && (ele.className.indexOf('normal') > -1 || ele.className.indexOf('block') > -1))
                let y = 0, y1= 0
                let moveCheck = false
                if(this.show && !check) {
                    y = e.touches[0] && e.touches[0].clientY
                    this.$refs.menu.ontouchmove = (e1) => {
                        moveCheck = true
                        e1.preventDefault();
                        e1.stopPropagation()
                        y1 = e1.touches[0] && e1.touches[0].clientY  
                        if(y1 > y) y = y1        
                    }
                    this.$refs.menu.ontouchend = (e2) => {
                        if(y - y1 > 50 && moveCheck) {
                            this.show = false
                            this.openStatus = false
                            this.$refs.menu.ontouchmove = null
                            this.$refs.menu.ontouchend = null
                        }
                    }
                }
            }
        }
        
    }
}
</script>
<style lang="scss">
    .header {
        height: 55px;
        width: 100%;
        left: 0;
        top: 0;
        position: fixed;
        z-index: 999;
        background: transparent;
        box-sizing: border-box;
        padding: 0 124px;
        line-height: 55px;
        color: #c8c8c8;
        transition: top linear 500ms;
        background: rgba(0,0,0,0.7);
        &:not(.mobile) {
            min-width: 1200px;
        }
        &.collasp {
            .f-right {
                transform: translateY(-90px)
            }
        }
        &.dark:not(.mobile) {
            color: rgba(0,0,0,0.8);
            .active-main {
                color: rgba(0,0,0,1);
                &::after {
                    background: rgba(0,0,0,0.8);
                }
            }
            .f-right>div, .f-right>a{
                &::after {
                        background: rgba(0,0,0,0.8);
                    }
                &:hover {
                    color: rgba(0,0,0,0.8);
                }
            }
        }
        &.dark, &.mobile {
            .cn-btn {
                background: url("../assets/image/cn-dark.svg") no-repeat center;
            }
            .en-btn {
                background: url("../assets/image/en-dark.svg") no-repeat center;
            }
        }
        .f-right {
            transition: top linear 500ms;
            &>div, &>a {
                float: left;
                padding: 0 6px;
                margin-left: 40px;
                height: 55px;
                line-height: 55px;
                cursor: pointer;
                font-size: 14px;
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 0;
                    background: #2D61DD;
                    height: 2px;
                    top: 53px;
                    transition: .2s;
                }
                &:hover {                  
                    color: #e9e9e9;
                }
                &.active-main {
                    color: #e9e9e9;
                    &:after {
                        width: 100%;
                    }
                }
            }
            &>a:hover, &>div:not(.en-btn):hover{
                &::after {                
                    width: 100%;
                }
            }
        }
        .logo {
            display: block;
            height: 24px;
            top: 18px;
            position: absolute;
            z-index: 99;
        }
        .cn-btn, .en-btn {
            height: 24px;
            width: 40px;
        }
        .cn-btn {
            background: url("../assets/image/cn.svg") no-repeat center;
        }
        .en-btn {
            background: url("../assets/image/en.svg") no-repeat center;
        }
        
        &:not(.mobile) {
            .second-nav {
                position: absolute;
                width: 240px;
                z-index: 1;            
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
                padding: 28px 0;
                transition: clip linear 100ms;
                background: rgba(0,0,0,0.80);
                clip: rect(0, 500px, 0, 0);
                transition: clip .4s;
                &.center {                    
                    left: 50%;
                    transform: translateX(-50%);
                }
                &.show {
                    transition: clip .8s;
                    clip: rect(0, 500px, 940px, 0);
                }
                &>li {
                    white-space: nowrap;
                    text-align: center;
                    line-height: 64px;
                    .block>span::before{
                        top: 20px;
                    }
                    &>a, &>.block {
                        display: block;
                        height: 64px;
                        line-height: 64px; 
                        font-size: 0;
                        position: relative;
                        &>span{
                            position: relative;
                            font-size: 14px;
                            padding: 2px 0;
                            &::after {
                                content: "";
                                position: absolute;
                                width: 0;
                                height: 1px;
                                background: #fff;
                                left: 50%;
                                transform: translateX(-50%);
                                top: 100%;
                                transition: width .3s;
                            }
                        }
                        &:hover>span::after {
                            width: 100%;
                        }
                    }
                }
            }
            .third-nav {
                width: 200px;
                position: absolute;
                left: 100%;
                top: 0;
                transition: clip linear 200ms;
                background: rgba(0,0,0,0.80);
                clip: rect(0, 1200px, 0, -1000px);
                &.show {                    
                    clip: rect(0, 1200px, 300px, -1000px);
                }
                &::before {
                    top: 2px;
                }
                .title {
                    position: relative;
                    cursor: default;
                }
                li:not(.title) {
                    height: 42px;
                    line-height: 42px;
                    margin: 0;
                    text-align: center;
                    a,.block {
                        display: block;
                        line-height: 42px;
                        color: #ffffff;
                        font-size: 14px;
                        span {
                            position: relative;
                            padding: 2px 0;
                            &::after {
                                content: "";
                                position: absolute;
                                width: 0;
                                height: 1px;
                                background: #fff;
                                left: 50%;
                                transform: translateX(-50%);
                                top: 100%;
                                transition: width .3s;
                            }
                        }
                        &:hover span::after {
                            width: 100%;
                        }
                    }
                }
                .title {
                    font-size: 14px;
                    line-height: 32px;
                    color: #969696;
                    line-height: 42px;
                    background: rgba(41,41,41,0.69);
                }                
            }
        }
        &.mobile {
            padding: 0.7rem 1.2rem;
            height: 2.5rem;
            font-size: 0.8rem;
            font-weight: 500;
            position: absolute;
            .logo {
                position: relative;   
                top: 0;     
                height: 1rem;        
            }
            .en-btn, .cn-btn {
                background: none
            }
           &.show .mobile-header {
                position: absolute;
                width: 100%;
                height: 2.5rem;
                background: rgba(0,0,0,0.90);
                top: 0;
                left: 0;
                z-index: 2;
                .logo {
                    top: 0.7rem;
                    left: 1.2rem;
                }
            }
            .menu-icon {
                width: 1rem;
                height: 1rem;
                background: url("../assets/image/menu-white.svg") no-repeat center;
                background-size: 0.7rem; 
                position: absolute;
                right: 0;
                top: 0;
                width: 2.8rem;
                height: 2.5rem;
                z-index: 99;
            }
            i.passive {
                color: #ACACAC
            }
            &.dark {
                .menu-icon {
                    background: url("../assets/image/menu.svg") no-repeat center;
                    background-size: 1.2rem; 
                }
            }
            &.show {
                height: 100%;
                background: #ffffff;
                .menu-icon {
                     background: url("../assets/image/close-white.svg") no-repeat center;
                     background-size: 0.9rem; 
                }
            }
            .menu-list {
                position: absolute;
                height: 0;
                overflow: auto;
                top: 0;                
                left: 0;
                width: 100%;
                box-sizing: border-box;
                background: #000;
                color: #fff;
                line-height: 2.8rem;  
                margin-top: 2.5rem;
                a:active {
                    background: #666;
                }  
                &>a {                    
                    padding-left: 2.4rem;
                }            
                &>a, &>div {   
                    display: block;
                    margin: 0 auto;
                    position: relative;
                    &>span {
                        display: block;                          
                        padding-left: 2.4rem; 
                    }
                    &>span {
                        position: relative;
                        &::after {
                            content: "";
                            position: absolute;
                            width: 0.8rem;
                            height: 0.8rem;
                            background: url("../assets/image/arrows@3x.svg") no-repeat center;
                            background-size: contain;
                            right: 1rem;
                            top: 1rem;
                            transition: all linear 100ms;
                        }
                    }
                    span.active {
                        background: #222222;
                        &::before {
                            content: "";
                            position: absolute;
                            width: calc(100% - 2rem);
                            height: 1px;
                            background: #4A4A4A;
                            top: 2.5rem;
                            left: 1rem;
                        }
                        &::after {
                            transform-origin: 50% 50%;
                            transform: rotate(-180deg)
                        }
                    }

                }
                &.show {
                    height: calc(100% - 2.5rem);
                }
            }
            .second-nav {
                position: relative;
                border: 0;
                line-height: 2.8rem;
                width: 100%;
                height: auto;
                background: #222222;
                overflow: hidden;
                transition: .2s;
                &.show {                    
                    &>li {
                        height: 2.8rem;
                        &.has-child {
                            height: auto;        
                            .block>span {
                                    &::after {
                                    content: "";
                                    position: absolute;
                                    width: 0.8rem;
                                    height: 0.8rem;
                                    background: url("../assets/image/arrows@3x.svg") no-repeat center;
                                    background-size: contain;
                                    right: 1rem;
                                    top: 1rem;
                                    transition: all linear 100ms;
                                } 
                                &.active::after{
                                    transform: rotate(-180deg)
                                }
                            }            
                        }
                    }
                }
                &>li {
                    position: relative;
                    width: 100%;
                    text-align: left;
                    border: 0;
                    height: 0;
                    display: block;
                    white-space: normal;                    
                    overflow: visible;
                    transition: .2s;
                    &>a,&>div {
                        display: block;
                        &>span {
                            display: block;
                            padding-left: 4rem
                        }
                    }
                }
            }
            .third-nav {
                position: relative;
                &.show {
                    li{
                        height: 2.8rem;
                        &.title:nth-child(5):after {
                            content: "";
                            position: absolute;
                            width: calc(100vw - 2rem);
                            left: 1rem;
                            height: 1px;
                            top: 0px;
                            background: #4A4A4A;
                        }
                    }
                }
                li {
                    transition: .2s;
                    height: 0;
                    a {
                        display: block;
                        span {
                            display: block;
                            padding-left: 10.8rem;
                        }
                    }
                    &.title {
                        position: absolute;
                        padding: 0;
                        color: #a2a2a2;
                        span {
                            padding-left: 5.75rem;
                        }
                        
                    }
                }
            }
        }
    }
    .english .header:not(.mobile) {
        .f-right .block:nth-of-type(1) {
            .second-nav {
                width: 280px
            }
        }
    }
    .english .header.mobile {
        .menu-list {
            &>a, &>.block>span {
                padding-left: 1.2rem;
                letter-spacing: 0
            }
        }
        .second-nav>li {
            &>div, &> a {
                display: block;
                span {
                    padding-left: 2.2rem;
                    letter-spacing: 0
                }
            }
        }
        .third-nav  {
            li.title>span {
                padding-left: 3.65rem;
                letter-spacing: 0
            }
            li:not(.title) a{
                span {
                    padding-left: 12.8rem;
                    letter-spacing: 0
                }
            }
        }
    }
</style>